<template>
    <div @scroll="handleScroll" ref="pageView" class="detail-page"
         :style="{'height':bSecret?'100vh':'','overflow':bSecret?'hidden':''}">
        <div>
            <!--    施工状态    -->
            <div class="construction-state-warp" v-if="!bSecret">
                <div class="construction-state-content">
                    <!--  信息容器  -->
                    <div class="info-view">
                        <!--     状态标签   -->
                        <div class="state-tag">{{ projectDetail.status | projectStatus }}</div>
                        <!--                    标题 -->
                        <div class="info-title">
                            <!-- <span>{{ projectDetail.type }}</span>
                            <span>{{ " | " }}</span> -->
                            <span>{{ projectDetail.type ? projectDetail.type + " | " : "" }}{{
                                    projectDetail.city ? projectDetail.city : ""
                                }}{{ projectDetail.community_name ? projectDetail.community_name : "" }}项目案例
                            </span>
                        </div>
                        <!--      时间分享信息      -->
                        <div class="info-time-share">
                            <div class="time-share-item" v-for="item in arrInfoStateTList" :key="item.id">
                                <img :src="item.icon" alt=""/>
                                <span>{{ item.value || '' }}</span>
                            </div>
                        </div>
                        <!--  配置参数-->
                        <div class="info-option">
                            <div v-for="(item, index) in arrInfoOptionList" :key="item.id" class="info-option-item"
                                 v-if="index < 3">
                                <div class="info-option-item">
                                    <span class="option-value" :class="{ 'num-value': item.util }">
                                        <span>{{ item.value || '' }}</span>
                                        <span class="util" v-if="item.util">{{ item.util }}</span>
                                    </span>
                                    <span class="mini-title">{{ item.name }}</span>
                                </div>
                            </div>
                            <div class="info-option-item">
                                <span class="option-value"
                                      :class="{ 'num-value': arrInfoOptionList[3].value != 0, 'num-value-text': arrInfoOptionList[3].value == '智慧集成系统' }">
                                    <span>{{ arrInfoOptionList[3].value != 0 ? arrInfoOptionList[3].value : '' }}</span>
                                    <span class="util"
                                          v-if="arrInfoOptionList[3].value != 0">{{ arrInfoOptionList[3].util }}</span>
                                </span>
                                <span class="mini-title">{{
                                        arrInfoOptionList[3].value != 0 ? arrInfoOptionList[3].name : ''
                                    }}</span>
                            </div>
                        </div>
                        <!--                    家庭成员-->
                        <div class="info-family">
                            <div class="title" v-if="objFamilyInfo.count">家庭成员</div>
                            <div class="num" v-if="objFamilyInfo.count">{{ objFamilyInfo.count }}人</div>
                            <div v-if="objFamilyInfo.desc">({{ objFamilyInfo.desc }})</div>
                        </div>
                    </div>
                    <!--  状态容器  -->
                    <div class="state-view">
                        <!--                    单个状态项-->
                        <div class="state-cons-item" :class="{ 'active-state-cons-item': item.state <= arrConstState }"
                             v-for="(item, index) in arrConstStateList" :key="item.id">
                            <div class="line-icon">
                                <div class="line" :class="{ 'line-hidden': index === 0 }"></div>
                                <div class="line" :class="{ 'line-hidden': index === arrConstStateList.length - 1 }">
                                </div>
                                <img v-if="item.state <= arrConstState" class="select-icon"
                                     :src="require('@/assets/images/project-detail/select-icon.png')" alt=""/>
                                <img v-else class="select-icon"
                                     :src="require('@/assets/images/project-detail/select-icon-no.png')" alt=""/>
                            </div>
                            <!--            这里的4指的是文字的长度，处理换行                -->
                            <div class="title" :class="{ 'font-qu': item.name.split('').length <= 4 }">{{ item.name }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="user-headImg-box" v-if="!isCurrent">
                <div class="user-headImg">
                    <div class="headImg-top" @click="getToAssList">
                        <div class="more-top">其他用户评价（{{ total_num }}）</div>
                        <div class="more-top-right">
                            <div class="top-look-more">查看全部</div>
                            <div class="top-look-icon"><img
                                :src="require('@/assets/images/member/v2/plan/right_ico.png')"/></div>
                        </div>
                    </div>
                    <div class="headImg-box">
                        <div v-for="(item,index) in arrHeadImg" :key="index" v-if="index < 5" class="head-name-box">
                            <div class="head-img-assess"><img
                                :src="item.img + '?x-oss-process=image/resize,m_fill,h_90'"/></div>
                            <div class="assess-name">{{ item.name }}</div>
                        </div>
                        <div class="more-assess-box" v-if="arrHeadImg.length > 5">
                            <div class="head-img-assess"><img :src="require('@/assets/images/project/more-icon.png')"/>
                            </div>
                            <div class="assess-name">更多</div>
                        </div>
                    </div>
                </div>
            </div>


            <!-- 用户评价 - 暂时不需要了 -->
            <div class="user-assess" v-if="isCurrent">
                <!-- v-if="nAssess" -->
                <div class="assess-box" v-if="nAssess">
                    <div class="top-box">
                        <div class="top-left">用户评价</div>
                        <div class="top-right" @click="getToAssList">查看其他用户评价<img
                            :src="require('@/assets/images/member/v2/plan/right_ico.png')"/></div>
                    </div>
                    <div class="assess-label">
                        <div :class="nLabelIndex == index ? 'lable-item' : 'label-item'"
                             v-for="(item, index) in arrAssess" :key="index" v-if="index < 3"
                             @click="changeLabel(index, item.title)">
                            {{ item.title }}{{ item.num }}
                        </div>
                    </div>
                    <div class="user-info" @click="getToAssList">
                        <div class="user-left-box">
                            <div class="head-img" v-if="nHeadimgurl"><img :src="nHeadimgurl"/></div>
                            <div class="user-name">
                                <div class="current-name">
                                    <div class="name" v-if="nNickname">{{ nameHide(nNickname) }}</div>
                                    <div v-if="isCurrent" class="current">本案例用户评价</div>
                                </div>
                                <div class="time">{{ nUpdated_at }}</div>
                            </div>
                        </div>
                        <div v-if="isZxy" class="user-right-box" @click.stop="toShare">
                            <img :src="require('@/assets/images/project/share-icon.png')"/>
                            <span>分享</span>
                        </div>
                    </div>

                    <div v-for="(item, index) in arrAssList" :key="index">
                        <div v-if="item.open">
                            <div class="assess-stars">
                                <div class="stars-title" v-if="item.is_completed == 3">系统施工评价</div>
                                <div class="stars-title" v-if="item.is_completed != 3 && item.is_completed != '追评'">
                                    竣工交付评价
                                </div>
                                <div class="stars-title" v-if="item.is_completed == '追评'">{{
                                        computTime(item.created_at)
                                    }}后追评
                                </div>
                                <el-stare v-if="item.score != ''" :numScore="Number(item.score)"></el-stare>
                                <div v-if="item.score != ''">{{ item.score }}分</div>
                            </div>
                            <div class="assess-content">{{ item.content }}</div>
                            <div class="assess-voice" v-if="item.voice" @click="handlePlay(index)">
                                <div style="display: flex;">
                                    <span>{{ item.voice_time }}s</span>
                                    <div class="voice-icon">
                                        <img :src="require('@/assets/images/project/voice-icon.png')"/>
                                        <img class="icon1" :src="require('@/assets/images/project/voice-icon1.png')"/>
                                        <div :id="'meng' + index" class="mengceng" style="display: none"></div>
                                    </div>
                                </div>
                                <div class="triangle-icon"></div>
                                <audio :id="'audio' + index" :src="item.voice"></audio>
                            </div>
                            <div class="assess-imgae" v-if="item.pic">
                                <div v-for="(im, ic) in item.pic" :key="ic" class="assess-imgae-item">
                                    <img :src="im.pic + '?x-oss-process=image/resize,m_fill,h_90'"
                                         v-if="im.type == 'image'" @click="getShow(item.pic, ic)"></img>
                                    <img :src="im.pic + '?x-oss-process=video/snapshot,t_1000,m_fast'"
                                         v-if="im.type == 'video'"
                                         @click="getShow(item.pic, ic)"></img>
                                    <div :id="'mantle' + index + ic" class="video_mantle" @click="getShow(item.pic, ic)"
                                         v-if="im.type == 'video'">
                                        <img :src="require('@/assets/images/icon_play.png')"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="arrAssList.length > 1">
                        <div class="look-more" v-if="!nSacseny" @click="changeAsscss('all')">
                            <span>看查完整评价</span><img :src="require('@/assets/images/project/down_icon.png')"/>
                        </div>
                        <div class="look-more-item" v-else @click="changeAsscss('stow')">
                            <span>收起评价</span><img :src="require('@/assets/images/project/down_icon.png')"/>
                        </div>
                    </div>
                </div>
            </div>

            <!--    切换导航栏    -->
            <div class="nav-wrap">
                <div class="nav-item" :class="{ 'active-nav-item': $route.path === item.path }"
                     v-for="item in arrNavBarList" :key="item.id" @click="navToChildRouter(item.path)">
                    <div class="nav-item-title">{{ item.name }}</div>
                    <div class="line-content"></div>
                </div>
            </div>

            <!--   子路由视图     -->
            <router-view></router-view>

        </div>
        <!--  目录  -->
        <transition name="fade-down">
            <div v-if="bCatalogVisible" class="catalog-content">
                <div @click.stop="handleCatalogClick(item.key)" class="catalog-item" :class="'catalog-' + item.key"
                     v-for="item in arrCatalogList" :key="item.key">
                    <img :src="item.icon" alt=""/>
                    <span>{{ item.name }}</span>
                </div>
                <!--      锚点目录      -->
                <transition name="fade">
                    <div v-if="bAnchorToastVisible" class="anchor-catalog">
                        <p class="item" @click.stop="navToGD(item.key)" v-for="item in navNowDate" :key="item.id">
                            {{ item.name }}
                        </p>
                    </div>
                </transition>
            </div>
        </transition>

        <!--    弹窗-分享    -->
        <ActionSheet v-model="bShareVisible" class="share-action-sheet">
            <div class="title-box">
                <span>分享方式</span>
                <img @click.stop="handleChangeShareVisible()"
                     :src="require('@/assets/images/project-detail/close-icon.png')" alt=""/>
            </div>
            <div class="share-box">
                <!--                <div class="share-item">-->
                <!--                    <div class="i-title">-->
                <!--                        <img :src="require('@/assets/images/project-detail/share-file-icon.png')" alt=""/>-->
                <!--                        <p>链接分享到朋友圈</p>-->
                <!--                    </div>-->
                <!--                    <div class="btn" :data-clipboard-text="sLink" id="express" @click="getCopy">-->
                <!--                        复制-->
                <!--                    </div>-->
                <!--                </div>-->
                <div class="share-item" v-for="share in arrShareMethod" :key="share.id">
                    <div class="i-title">
                        <img :src="share.icon" alt=""/>
                        <p>{{ share.name }}</p>
                    </div>
                    <div class="btn" @click.stop="triggerEvent(share.clickevent)">
                        {{ share.button }}
                    </div>
                </div>
            </div>
            <!-- <div class="btn_daochu">
                导出案例二维码
            </div> -->
        </ActionSheet>
        <!-- 分享海报 -->
        <van-popup class="share_popup" v-model="shareImg" :round="true">
            <div class="shareUrlWrap share-wrap" ref="canvas" @click="shareImg = false">
                <div class="topback" :style="{ background: 'url(' + sPosterUrl + ') no-repeat center/100% 100%' }">
                    <div class="shareinfo">
                        <div class="shareinfo_item" v-for="(item, index) in arrInfoOptionList" :key="index"
                             v-if="index < 3">
                            <div :class="item.key">{{ item.value }}<span>{{ item.util }}</span></div>
                            <span>{{ item.name }}</span>
                            <div class="xian"></div>
                        </div>
                        <div class="shareinfo_item">
                            <div :class="arrInfoOptionList[3].key">
                                {{ arrInfoOptionList[3].value != 0 ? arrInfoOptionList[3].value : '' }}
                                <span v-if="arrInfoOptionList[3].value != 0">{{ arrInfoOptionList[3].util }}</span>
                            </div>
                            <span>{{ arrInfoOptionList[3].value != 0 ? arrInfoOptionList[3].name : '' }}</span>
                            <div class="xian"></div>
                        </div>
                    </div>
                </div>
                <div class="code_info">
                    <div class="address">
                        {{ projectDetail | getAddress }}
                    </div>
                    <div>AI-LiNK冷暖风水专业集成项目案例</div>
                    <div class="code_url" id="qrcode" ref="qrcode">
                        <!-- <img src="" alt=""> -->
                    </div>
                    <div>扫码查看案例详情</div>
                    <div class="color_test">中央空调 · 采暖 · 新风 · 全屋用水</div>
                </div>
                <img v-if="codeUrl" :src="codeUrl" class="share-img" alt="">
            </div>
            <div class="btn_share" @click="shareImg = false">长按保存图片到相册</div>
        </van-popup>
        <el-agree ref="agreement" @resfuss="resfuss"></el-agree>
        <!-- <loading :load="true" :loadBg="true"></loading> -->
        <!-- <div class="mencheng" v-if="isMentShow">
            <div v-if="isType == 'image'" class="meng-img">
                <img class="meng-image" :src="nMentUrl" @click="isMentShow = false" />
            </div>
            <div v-if="isType == 'video'" class="meng-img">
                <video id="videoUrl" :src="nMentUrl" />
                <div id="mantle" class="video_mantle" @click="playVideo2">
                    <img :src="require('@/assets/images/icon_play.png')" />
                </div>
            </div>
            <div class="close_icon" @click="isMentShow = false">
                <img :src="require('@/assets/images/antV2/icon_del.png')" />
            </div>
        </div> -->

        <div class="swipe-box" v-if="imgShow">
            <van-swipe @change="swipeChaneg" :initial-swipe="nChangeIndex">
                <van-swipe-item v-for="(item, index) in arrStausImg" :key="index">
                    <div class="swipe-image" v-if="item.type == 'image'"><img
                        :src="item.pic+ '?x-oss-process=image/resize,w_800'"/></div>
                    <div v-if="item.type == 'video'" class="meng-img">
                        <video id="videoUrl" controls
                               :poster="item.pic+ '?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,ar_auto'"
                               :src="item.pic"/>
                        <!-- <video id="videoUrl" :src="item.pic"/>
                        <div class="video-img" id="video-img">
                            <img :src="item.pic + '?x-oss-process=video/snapshot,t_1000,m_fast'"/>
                        </div>
                        <div id="mantle" class="video_mantle" @click="playVideo2">
                            <img :src="require('@/assets/images/icon_play.png')"/>
                        </div> -->
                    </div>
                </van-swipe-item>
            </van-swipe>
            <div class="directive">{{ nChangeIndex + 1 }}/{{ arrStausImg.length }}</div>
            <div class="swipe-close" @click="imgShow = false">
                <img :src="require('@/assets/images/antV2/icon_close.png')"/>
            </div>
        </div>
        <!-- 海报 -->
        <div class="poster" :style="{background:!sBase64?'none':'rgba(0,0,0,0.6)'}" v-if="isShowPoster">
            <div class="poster-content" ref="canvas" id="capture">
                <div class="top-title">
                    <div class="text">{{ objPoster.poster_title || '“很满意史密斯这次的服务，采暖、 空调效果也非常好”' }}</div>
                    <div class="name">—— {{ objPoster.city }}用户 {{ objPoster.name }}</div>
                </div>
                <div class="poster-bgc">
                    <img v-if="objPoster.poster_pic" :src="objPoster.poster_pic" alt="">
                    <img v-else src="@/assets/images/share/top-bgc.png" alt="">
                </div>
                <div class="title">{{ objPoster.city }} ｜ {{ objPoster.project_name2 }}</div>
                <div class="info">
                    <div class="info-item">
                        <img src="@/assets/images/share/rl.png" alt="">
                        <span>{{ objPoster.date.split(' ')[0] }}</span>
                    </div>
                    <div v-if="objPoster.house_cate" class="info-item">
                        <img src="@/assets/images/share/bs.png" alt="">
                        <span>{{ objPoster.house_cate }}</span>
                    </div>
                    <div v-if="objPoster.house_area" class="info-item">
                        <img src="@/assets/images/share/mj.png" alt="">
                        <span>{{ objPoster.house_area }}㎡</span>
                    </div>
                </div>
                <div class="qr-wrap">
                    <div class="qr-left">
                        <div class="top-qr">
                            <div class="name">{{ objPoster.nickname }}</div>
                            <div class="tag">高级服务顾问</div>
                        </div>
                        <div class="b-qr">
                            <div>长按识别，了解</div>
                            <div>用户真实使用体验</div>
                        </div>
                    </div>
                    <div class="qr-right" id="qr-right" ref="qrcode"></div>
                    <div class="qr-head">
                        <img :src="objPoster.headimgurl" alt="">
                    </div>
                </div>
                <div class="b-bg">
                    <div class="logo-img">
                        <img src="@/assets/images/share/logo2.png" alt="">
                        <span>AI-LiNK好风好水智慧集成</span>
                    </div>
                    <div class="sp">
                        <img src="@/assets/images/share/sp3.png" alt="">
                    </div>
                </div>
            </div>
            <div v-if="sBase64" class="poster-content-img-wrap">
                <div class="poster-content-img">
                    <img :src="sBase64" alt="">
                    <img class="close" @click="closePoster" src="@/assets/images/share/close_icon.png" alt="">
                    <div class="tips-save">*长按保存图片<br/>*朋友圈文字已复制</div>
                </div>
            </div>
        </div>
        <!-- 分享弹框 -->
        <div class="share-popup" v-if="isShowSharePopup" @click.stop="isShowSharePopup = false">
            <div class="share-content" @click.stop>
                <div class="share-title">请选择分享方式</div>
                <div class="share-wrap">
                    <div class="share-item" @click="toPoster">
                        <img src="@/assets/images/share/poster.png" alt="">
                        <span>生成海报</span>
                    </div>
                    <!--                    <div class="share-item" @click="toCopy">-->
                    <!--                        <img src="@/assets/images/share/ljp.png" alt="">-->
                    <!--                        <span>分享链接</span>-->
                    <!--                    </div>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {getEvaPoster, readNum, shareNum} from '@/js/project/share.js'
import {ActionSheet} from "vant";
import {Toast} from "mint-ui";
import {mapState} from "vuex";
// import html2canvas from "html2canvas";
import html2canvas from "@/libsV2/html2canvas";
import QRCode from "qrcodejs2";
import oDetail from "@/js/detail";
import {getWxSingleConfig} from "@/js/wx.js";
import elAgree from "@/components/agree/index";
import URLAPI from "@/libsV2/urlApi";
import {getProjectInfo, getProjectList, v2tov3id} from "@/js/project/evaluation.js"
import elStare from '@/components/stares/stares'
import oRequest from "@/libsV2/request";

export default {
    name: "detailIndex",
    components: {
        ActionSheet,
        elAgree,
        elStare
    },
    data() {
        return {
            objShareInfo: [],//分享的评价
            sBase64: '',
            objPoster: {},//海报信息
            isShowPoster: false,//海报
            share_link: '',//分享链接
            isShowSharePopup: false,
            bSecret: false,
            codeUrl: "",
            sPosterUrl: "", //海报头部图片背景链接
            shareImg: false, //海报
            // 导航渲染数组
            arrNavBarList: [{
                name: "定制方案",
                path: "/project/detail/custom",
            },
                {
                    name: "工地直击",
                    path: "/project/detail/construction",
                },
                {
                    name: "服务团队",
                    path: "/project/detail/team",
                },
                // {
                //     name: "用户评价",
                //     path: "/project/detail/evaluation",
                // },
            ],
            // 状态信息时间分享查看
            arrInfoStateTList: [{
                icon: require("@/assets/images/project-detail/date-icon.png"),
                key: "created_at",
                value: "2021-04-02",
            },
                {
                    icon: require("@/assets/images/project-detail/share-icon.png"),
                    key: "shares",
                    key2: 'real_shares',
                    value: 573,
                },
                {
                    icon: require("@/assets/images/project-detail/watch-icon.png"),
                    key: "views",
                    key2: 'real_views',
                    value: 1453,
                },
            ],
            // 配置参数数组
            arrInfoOptionList: [{
                name: "建筑面积",
                key: "house_area_name",
                util: "m²",
                value: "",
            },
                {
                    name: "房型",
                    keys: ["house_type_name", "house_type_room_name"],
                    key: "house_type_name",
                    value: "",
                },
                {
                    name: "房屋类型",
                    key: "house_cate_name",
                    value: "",
                },
                // {
                //     name: "项目造价",
                //     key: "quoted_price",
                //     util: "万",
                //     value: "0",
                // },
                {
                    name: "案例类型",
                    key: "type",
                    value: "",
                },
            ],
            // 项目的状态数组
            arrConstStateList: [
                // {
                //     name: "进场定位",
                //     state: 0,
                // },
                // {
                //     name: "空调施工",
                //     state: 1,
                // },
                // {
                //     name: "采暖施工",
                //     state: 2,
                // },
                // {
                //     name: "新风施工",
                //     state: 3,
                // },
                // {
                //     name: "设备安装系统调试",
                //     state: 4,
                // },
                // {
                //     name: "安装效果",
                //     state: 5,
                // },
            ],
            // 项目的状态
            arrConstState: -1,
            // 目录显示
            bCatalogVisible: false,
            // 滚动值
            nScrollTop: 0,
            // 是否收藏
            isCollect: 0,
            // 目录锚点显示
            bAnchorToastVisible: false,
            // 锚点前缀
            sAnchorBefore: "S_t_k",
            // 分享弹窗显示
            bShareVisible: false,
            // 目录数组
            arrCatalogList: [{
                name: "目录",
                icon: require("@/assets/images/project-detail/g-menu-icon.png"),
                key: "menu",
            },
                {
                    name: "收藏",
                    icon: require("@/assets/images/project-detail/g-save-icon.png"),
                    key: "save",
                },
                {
                    name: "分享",
                    icon: require("@/assets/images/project-detail/g-share-icon.png"),
                    key: "share",
                },
            ],
            // 分享方式
            arrShareMethod: [
                // {
                //     icon: require("@/assets/images/project-detail/share-file-icon.png"),
                //     key: "link",
                //     name: "链接分享到朋友圈",
                //     button: "复制",
                //     link: location.href,
                //     clickevent: "getCopy",
                // },
                {
                    icon: require("@/assets/images/project-detail/qr_icon.png"),
                    key: "share",
                    name: "分享到会话",
                    button: "分享",
                    clickevent: "getShare",
                },
                // {
                //     icon: require("@/assets/images/project-detail/share-qr-icon.png"),
                //     key: "banner",
                //     name: "生成口碑海报",
                //     button: "生成海报",
                //     clickevent: "htmlToImage",
                // },
                // {
                //     icon: require('@/assets/images/project-detail/share-image-icon.png'),
                //     key: 'image',
                //     name: '生成长图',
                //     button: '生成长图'
                // }
            ],
            shareConfit: {}, //分享配置
            // 定制导航数据
            arrCustomerNavList: [
                // {
                //   name: "房屋特性",
                //   key: "roomC",
                // },
                {
                    name: "用户个性化需求",
                    key: "userC",
                },
                {
                    name: "设计参数",
                    key: "designC",
                },
                {
                    name: "系统功能",
                    key: "functionC",
                },
                {
                    name: "系统配置",
                    key: "systemC",
                },
            ],
            // 家庭信息
            objFamilyInfo: {
                count: 5,
                desc: "",
            },
            sLink: '',
            arrAssess: [],
            arrAssList: [],
            isLine: false,
            isSore: true,
            audioUrl: '',
            isPlay: true,
            isCurrent: false,
            acc_id: '',
            nLabelIndex: '-1',
            nSacseny: false,
            isContShow: true,
            nNaveShow: true,
            nMentUrl: '',
            isMentShow: false,
            isType: '',
            nTimeNum: '',
            nAssess: true,
            isShow: false,
            imgShow: false,
            lookImgIndex: 0,
            arrStausImg: [],
            nChangeIndex: 0,
            nHeadimgurl: '',
            nNickname: '',
            nUpdated_at: '',
            arrHeadImg: [],
            total_num: '',
            isZxy: false
        };
    },
    watch: {
        /**
         * 监听报告详情
         * @param value
         */
        reportDetail(value) {
            this.saveReportInfoToView(value);
            this.changeCatalogList();
        },
        projectDetail(value) {
            // oRequest.reportErr('projectDetail', {type: 'log',msgText: '项目详情'}, value)
            this.objFamilyInfo.count = value.people
        }
    },
    filters: {
        getAddress(e) {
            // console.log(e)
            return e.city + " " + "|" + " " + e.area_name + e.plot_name;
        },
        // 项目状态
        projectStatus(v) {
            switch (v) {
                case "signed":
                    return "已签约";
                case "under-construction":
                    return "施工中";
                default:
                    return "已完工";
            }
        },
    },
    created() {
        //23-5-31 项目3.0上线，详情老版本重定向到3.0
        //分享的路径转化成3.0的链接参数
        //老版本是通过project_uuid查询数据，3.0是通过3.0的项目id查询数据，通过接口转化
        let query = '';
        v2tov3id({
            project_id: this.$route.query.acc_id
        }).then((res) => {
            let id = res.data.data.result.project_id;
            if (this.$route.query.track_action) {
                query = `?mode=2&id=${id}&ut_source=${this.$route.query.ut_source}` +
                    `&project_uuid=${this.$route.query.acc_id}&shareId=${this.$route.query.shareId}` +
                    `&track_action=project_share_discuss&track_id=${id}&track_uuid=${this.$route.query.track_uuid}`
            } else {
                query = `?id=${id}&mode=1&ut_source=${this.$route.query.ut_source}`
            }
            this.$router.replace({
                path: `/project/v3/case/details${query}`,
            });
        })
        return;

        const {
            id,
            qywxUserId,
            ut_source,
            shareId,
            xcxShare,
            bSelfDemo,
            bXcxShare
        } = this.$route.query;
        this.acc_id = this.$route.query.acc_id
        $init(() => {
            oDetail.getAuthorZxy().then((res) => {
                this.isZxy = res.result;
            });

            console.log(bSelfDemo, 'bSelfDemo')
            if (bSelfDemo == 'true' || bXcxShare == 1) {
                // this.$toast('分享统计')
                shareNum({
                    project_uuid: this.$route.query.acc_id,
                    sfrom: 'koubei',
                    from_id: qywxUserId,
                    zhuanfa_type:'koubei'
                }).then()
            }
            // getWxSingleConfig();
            this.$store.commit("loadSwitch", true);
            this.$store.dispatch({
                type: "proposalModule/fetchPlantDetail",
                id: id,
                ut_source: ut_source
            }).then(() => {
                this.$store.commit("loadSwitch", false);
                this.getUserInfo();
            });
            this.getAssessList(this.acc_id)
            this.getAssess(this.acc_id)
            if (qywxUserId != undefined && qywxUserId != 'undefined') {
                oDetail.getEnterpriseShare({
                    from_id: qywxUserId,
                    project_id: id,
                    sfrom: ut_source,
                })
            }
            // if(shareId>0 || xcxShare>0){
            //     oDetail.getShareRen({
            //         from_id: shareId || xcxShare,
            //         project_id: id,
            //     }).then(res=>{})
            // }
        });
    },
    computed: {
        /**
         * 是否处于工地直击
         * @return {boolean}
         */
        isConstruction() {
            return (
                this.arrNavBarList.find(({
                                             name
                                         }) => name === "工地直击")
                    .path === this.$route.path
            );
        },
        ...mapState({
            // 类目数组
            arrCategoryList: (state) =>
                state.projectDetailConstruction.arrCategoryList,
            // 定制方案展开视频ref
            objVideoRef: (state) => state.projectDetailCustom.objVideoRef,
            // 路由位置
            objRouterPosition: (state) =>
                state.projectDetailConstruction.objRouterPosition,
            // 方案书详情
            reportDetail: (state) => state.proposalModule.plantDetail,
            // 项目详情
            projectDetail: (state) => state.proposalModule.projectDetail,
        }),
        // 导航当前循环数据
        navNowDate() {
            return this.isConstruction ?
                this.arrCategoryList :
                this.arrCustomerNavList;
        },
    },
    mounted() {
        this.saveIndexRef();
        this.sLink =
            `${window.location.protocol}//${window.location.host}${window.location.pathname}?id=${this.$route.query.id}&shareId=${this.$storage.getStorage("user_id")}&qywxUserId=${this.$storage.getStorage("user_id")}&ut_source=${this.$route.query.ut_source}&acc_id=${this.acc_id}`
        // 滚动到上次的位置
        // this.$refs.pageView.scrollTop = this.$store.state.scrollTop;
    },
    beforeRouteLeave(to, from, next) {
        if ((to.meta.title = "用户评价")) {
            this.$store.commit("editScrollTop", this.nScrollTop);
        } else {
            this.$store.commit("editScrollTop", 0);
        }
        next();
    },
    methods: {
        // 关闭海报
        closePoster() {
            this.sBase64 = ''
            this.isShowPoster = false
        },
        // 获取海报基本信息
        getBaseInfo(project_uuid) {
            let that = this
            getEvaPoster({
                project_uuid: project_uuid,
            }).then(res => {
                // oRequest.reportErr('project/discuss/poster', {
                //     project_uuid: project_uuid,
                //     version: '2.0'
                // }, res)
                if (typeof (res.data.result) != 'string') {
                    this.objPoster = res.data.result
                    this.isShowPoster = true
                    this.$store.commit("loadSwitch", true);
                    setTimeout(() => {
                        let qr = new QRCode(this.$refs.qrcode, {
                            // text 需要转二维码的内容 可以是文本也可以是一个链接 是链接会直接跳走
                            text: this.share_link,
                            width: 148,
                            height: 148,
                            colorDark: '#333',//二维码颜色
                            colorLight: '#fff',//二维码背景颜色
                            correctLevel: QRCode.CorrectLevel.L//容错率,L/M/H
                        })
                        setTimeout(() => {
                            that.getShareImgBase64()
                        }, 500)
                    }, 500)
                } else {
                    this.$toast(res.data.result)
                    this.$store.commit("loadSwitch", false);
                }
                console.log(res, '信息')
            }).catch(err => {
                this.$toast('请求失败')
                this.$store.commit("loadSwitch", false);
                console.log(err, '信息2')
            })
        },
        // 海报
        toPoster() {
            this.toCopy('1')
            this.getBaseInfo(this.objShareInfo[0].project_uuid)
        },
        // 点击分享
        toShare() {
            this.isShowSharePopup = true
            this.objShareInfo = this.arrAssList
        },
        // 获取分享图片 base64
        getShareImgBase64() {
            let that = this
            let sHeight = that.$refs.canvas.offsetHeight;
            let sWidth = that.$refs.canvas.offsetWidth;
            console.log(sHeight, sWidth, '截图高度')
            setTimeout(() => {
                // #capture 就是我们要获取截图对应的 DOM 元素选择器
                html2canvas(that.$refs.canvas, {
                    allowTaint: true, // 允许跨域图片
                    useCORS: true,
                    height: sHeight,
                    width: sWidth,
                    x: 0,
                    y: 2 * window.innerHeight,
                    scrollX: 0,
                    scrollY: 0,
                    dpi: window.devicePixelRatio,
                    scale: 2,
                }).then((canvas) => {
                    that.isShowSharePopup = false
                    const imgData = canvas.toDataURL("image/png");
                    that.sBase64 = imgData
                    that.$store.commit("loadSwitch", false);
                    this.$common.pushEvent('project_share_discuss', this.objShareInfo[0].project_uuid);

                    // 统计转发数据
                    shareNum({
                        project_uuid: this.$route.query.acc_id,
                        sfrom: this.$route.query.ut_source,
                        from_id: this.$storage.getStorage("user_id"),
                    }).then()
                    console.log(imgData)
                });
            }, 500); // 这里加上 300ms 的延迟是为了让 DOM 元素完全渲染完成后再进行图片的生成
        },
        // 复制链接
        toCopy(type) {
            console.log('======>')
            let that = this
            let sTips = ""
            if (type != '1') {
                sTips = "A.O.史密斯AI-LiNK好风好水智慧集成系统真实用户体验，快点击查看吧~"
            } else {
                sTips = "A.O.史密斯AI-LiNK好风好水智慧集成系统真实用户体验，快扫码识别查看吧~"
            }
            //&track_action=share_project&track_id=${this.objShareInfo[0].project_uuid}&track_uuid=${sessionStorage.getItem('page_uuid')}
            this.share_link = `${window.location.origin}/project/share/index?project_uuid=${this.objShareInfo[0].project_uuid}&share_id=${this.$storage.getStorage('user_id')}&acc_id=${this.acc_id}` +
                `&track_action=project_share_discuss&track_id=${this.objShareInfo[0].project_uuid}&track_uuid=${sessionStorage.getItem('page_uuid')}` + `&sfrom=${this.$route.query.ut_source}&from_id=${this.$storage.getStorage("user_id")}`
            console.log(this.share_link, 'share_link333')
            // 创建模拟 输入框
            var cInput = document.createElement("input");
            // cInput.value =sTips+this.share_link;
            console.log(this.share_link)
            cInput.value = sTips;
            document.body.appendChild(cInput);
            cInput.select(); // 选取文本框内容
            // 执行浏览器复制命令
            // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
            // Input要在正常的编辑状态下原生复制方法才会生效
            document.execCommand("copy");
            // 复制成功后再将构造的标签 移除
            document.body.removeChild(cInput);
            if (type != '1') {
                this.$toast('复制成功')
                this.isShowSharePopup = false
            }

        },
        //音频播放
        handlePlay(index) {
            let id = 'audio' + index
            let idx = 'meng' + index
            let audio = document.getElementById(id)
            let ment = document.getElementById(idx)
            if (audio.paused) {
                console.log(1);
                audio.play();
                ment.style.display = 'block';
            } else {
                audio.pause();
                ment.style.display = 'none';
            }
            audio.addEventListener('ended', function () {
                audio.style.display = 'block';
                ment.style.display = 'none';
            });
        },
        swipeChaneg(e) {
            this.nChangeIndex = e
        },
        getShow(e, num) {
            let arr = []
            e.forEach(it => {
                arr.push({pic: it.pic, type: it.type})
            })
            this.nChangeIndex = num;
            this.imgShow = true;
            this.arrStausImg = arr;
        },
        nameHide(name) {
            if (name.length <= 1) {
                name
            } else if (1 <= name.length && name.length <= 2) {
                name = name[0] + '*'
            } else if (3 <= name.length) {
                name = name[0] + '***' + name[name.length - 1]
            }
            return name
        },
        //视频播放
        // playVideo(url, type) {
        //     this.isMentShow = true
        //     this.isType = type
        //     this.nMentUrl = url
        //     console.log(this.isType);
        // },
        playVideo2() {
            let video = document.getElementById('videoUrl');
            console.log(video);
            if (video.paused) {
                video.play();
                document.getElementById('mantle').style.display = 'none'
                document.getElementById('video-img').style.display = 'none'
            } else {
                video.pause();
                document.getElementById('mantle').style.display = 'block'
                document.getElementById('video-img').style.display = 'block'
            }
            video.addEventListener('ended', function () {
                document.getElementById('mantle').style.display = 'block'
                document.getElementById('video-img').style.display = 'block'
            });
        },
        assessNikeName(name) {
            if (name == null) {
                name == ''
            } else {
                if (name.length <= 1) {
                    name
                } else if (name.length > 1) {
                    name = name[0] + '*' + name[name.length - 1]
                }
            }
            return name
        },
        //获取评价列表
        getAssessList(id) {
            this.$store.commit("loadSwitch", true);

            getProjectList({
                page: 0,
                limit: 10000,
                project_uuid: id,
                type: 'all',
                sort: 'id',
                sort_type: 'desc',
            }).then(res => {
                console.log(res, 'resssss');
                this.total_num = res.data.result.total_num
                let list = res.data.result.lists
                let arr = []
                list.forEach((it, ix) => {
                    if (it.length) {
                        let obj = {}
                        obj = {
                            img: it[0].headimgurl,
                            name: this.assessNikeName(it[0].nickname)
                        }
                        arr.push(obj)
                    }
                })
                let filterArr = arr.filter(it => {
                    return it.img || it.name
                })
                this.$nextTick(() => {
                    this.$store.commit("loadSwitch", false);
                })
                this.arrHeadImg = filterArr
                console.log(filterArr, '评价列表arrrrrr');
            })
        },
        //获取评价信息
        getAssess(id) {
            this.$store.commit("loadSwitch", true);


            console.log(id, 'project_uuid');
            getProjectInfo({
                project_uuid: id,
            }).then(res => {
                let list = []
                if (res.data.result.lists.length < 1) {
                    this.nAssess = false
                    return
                }
                console.log(res.data.result.lists[0].project_uuid, 'project_uuid');

                console.log(res.data.result.lists[0], 'length');
                if (res.data.result.lists.length > 0) {
                    this.nHeadimgurl = res.data.result.lists[0].headimgurl
                    this.nNickname = res.data.result.lists[0].nickname
                    this.nUpdated_at = res.data.result.lists[0].updated_at
                }

                let arr = []
                res.data.result.lists.forEach(it => {
                    let obj = {}
                    obj.tags = []
                    obj.children = []
                    arr.push({...it, open: false})
                    if (it.content2 != '' && it.content2 != null) {
                        let zuipingObj = {
                            content: it.content2,
                            pic: it.pic_zhui,
                            created_at: it.zhui_time,
                            voice: '',
                            is_completed: '追评',
                            score: '',
                        }
                        arr.push({
                            ...zuipingObj,
                            open: true
                        })
                    }
                })
                console.log(arr, 'arrrrrrr');
                let idx = arr.findIndex(ele => ele.is_completed == '追评')
                if (idx != -1) {
                    arr[idx].open = true
                } else {
                    idx = arr.findIndex(ele => ele.is_completed == 3)
                    if (idx != -1) {
                        arr[idx].open = true
                    } else {
                        idx = arr.findIndex(ele => ele.is_completed == 1)
                        if (idx != -1) {
                            arr[idx].open = true
                        } else {
                            idx = arr.findIndex(ele => ele.is_completed == 2)
                            if (idx != -1) {
                                arr[idx].open = true
                            }
                        }
                    }
                }

                // arr.forEach((it, ik) => {
                // if (arr.length < 3) {
                //     if (this.findElem(arr, 'is_completed', '3') == -1) {
                //         if (it.is_completed == 1) {
                //             it.open = true
                //         }
                //     } else {
                //         if (it.is_completed == 3) {
                //             it.open = true
                //         }
                //     }
                // }
                // })
                this.arrAssList = arr
                console.log(arr, 'arr9090');

                this.arrAssess = res.data.result.tags
                console.log(id)
                if (id == res.data.result.lists[0].project_uuid) {
                    this.isCurrent = true
                } else {
                    this.isCurrent = false
                }
                if (this.arrAssList.content2 == null) {
                    this.isContShow = false
                } else {
                    this.isContShow = true
                }
                if (this.isCurrent) {
                    console.log('是本案例212已设置分享')
                    readNum({
                        project_uuid: this.$route.query.acc_id,
                        type: 'koubei'
                    }).then()
                }
                console.log(this.isCurrent, 'this.isContShow')
                let confit = {
                    share_link: `${window.location.protocol}//${window.location.host}${window.location.pathname}` +
                        `?id=${this.$route.query.id}&qywxUserId=${this.$storage.getStorage("user_id")}&ut_source=${this.$route.query.ut_source}` +
                        `&shareId=${this.$storage.getStorage("user_id")}&acc_id=${this.acc_id}` +
                        `&track_action=project_share_info&track_id=${this.$route.query.id}&track_uuid=${sessionStorage.getItem('page_uuid')}` +
                        `&bSelfDemo=${this.isCurrent}&sfrom=${this.$route.query.ut_source}&from_id=${this.$storage.getStorage("user_id")}`
                }
                console.log(confit, 'confit')
                this.wxStare(confit);
                this.$nextTick(() => {
                    this.$store.commit("loadSwitch", false);
                })
            })
        },
        //判断是否有这个值 没有则返回-1
        findElem(array, attr, val) {
            for (var i = 0; i < array.length; i++) {
                if (array[i][attr] == val) {
                    return i; //返回当前索引值
                }
            }
            return -1;
        },
        computTime(oldTime) {
            if (oldTime == null && oldTime == undefined) {
                return '1天'
            }
            let nowTime = new Date().getTime();  //现在时间 时间戳
            let endTime = oldTime.replace(/-/g, '/');
            let zhuiTime = new Date(endTime);
            zhuiTime = zhuiTime.getTime();
            let diffTime = (nowTime - zhuiTime) / 1000;
            let timeData = '';
            if (diffTime < 0) {
                timeData = '1天'
            } else if (0 < diffTime && diffTime < 86400) {
                timeData = '1天'
            } else if (86400 < diffTime && diffTime < 2592000) {
                timeData = parseInt(diffTime / 86400) + '天'
            } else if (2592000 < diffTime && diffTime < 31536000) {
                timeData = parseInt(diffTime / 2592000) + '个月'
            } else {
                timeData = parseInt(diffTime / 31536000) + '年'
            }
            return timeData
        },
        //跳转评价详情
        getToAssList() {
            //todo 正式先不上统计
            readNum({
                project_uuid: this.$route.query.acc_id,
                type: 'pool_discuss'
            }).then(res => {
                this.$router.push({
                    path: '/project/detail/assess',
                    query: {
                        acc_id: this.acc_id,
                        ut_source: this.$route.query.ut_source,
                    },
                });
            })
        },
        changeAsscss(type) {
            if (type == 'all') {
                this.arrAssList.forEach(it => {
                    if (!it.open) {
                        it.open = true
                    }
                })
                this.nSacseny = true
            } else {
                this.arrAssList.forEach(it => {
                    if (this.arrAssList.length > 2) {
                        if (it.is_completed != '追评') {
                            it.open = false
                        }
                    } else {
                        this.nSacseny = false
                        let arrzui = this.arrAssList.filter(it => {
                            return it.is_completed == '追评'
                        });
                        let arr3 = this.arrAssList.filter(it => {
                            return it.is_completed == 3
                        });
                        let arr2 = this.arrAssList.filter(it => {
                            return it.is_completed == 2
                        });
                        let arr1 = this.arrAssList.filter(it => {
                            return it.is_completed == 1
                        });
                        if (arrzui.length) {
                            this.arrAssList.forEach(it => {
                                if (it.is_completed != '追评') {
                                    it.open = false
                                }
                            })
                            return
                        } else if (arr3.length) {
                            this.arrAssList.forEach(it => {
                                if (it.is_completed != 3) {
                                    it.open = false
                                }
                            })
                            return
                        } else if (arr1.length) {
                            this.arrAssList.forEach(it => {
                                if (it.is_completed != 1) {
                                    it.open = false
                                }
                            })
                            return
                        } else if (arr2.length) {
                            this.arrAssList.forEach(it => {
                                if (it.is_completed != 2) {
                                    it.open = false
                                }
                            })
                            return
                        }
                    }
                })
            }
        },
        changeLabel(index, title) {
            this.nLabelIndex = index
            this.$router.push({
                path: '/project/detail/assess',
                query: {
                    acc_id: this.acc_id,
                    title: title,
                    label: index,
                },
            });
        },
        //用户信息
        getUserInfo() {
            let that = this;
            oDetail.getInfo().then((res) => {
                if (res.result.ant_secret == 0) {
                    this.bSecret = true;
                    this.$refs.agreement.show()
                }
            });
        },
        resfuss() {
            this.bSecret = false;
        },
        triggerEvent(operation) {
            this[operation]();
        },
        // 分享会话
        getShare() {
            this.$common.pushEvent('project_share_info', this.$route.query.id);
            let wechat = this.$storage.getStorage("is_wechat");
            if (wechat == 1) {
                Toast({
                    message: "请点击右上角···转发哦~"
                });
            } else if (wechat == 6) {
                this.getQyhh();
            }
        },
        // 删除url中某个参数,并跳转
        funcUrlDel(name) {
            var loca = window.location;
            var baseUrl = loca.origin + loca.pathname + "?";
            var query = loca.search.substr(1);
            if (query.indexOf(name) > -1) {
                var obj = {}
                var arr = query.split("&");
                for (var i = 0; i < arr.length; i++) {
                    arr[i] = arr[i].split("=");
                    obj[arr[i][0]] = arr[i][1];
                }
                ;
                delete obj[name];
                var url = baseUrl + JSON.stringify(obj).replace(/[\"\{\}]/g, "").replace(/\:/g, "=").replace(/\,/g,
                    "&");
                return url
            }
            ;
        },
        // 复制
        getCopy() {
            let that = this;
            let clipboard = new this.$clipboard('#express', {
                text: () => {
                    return `${window.location.protocol}//${window.location.host}${window.location.pathname}` +
                        `?id=${this.$route.query.id}&qywxUserId=${this.$storage.getStorage("user_id")}&ut_source=${this.$route.query.ut_source}` +
                        `&shareId=${this.$storage.getStorage("user_id")}&acc_id=${this.$route.query.acc_id}` +
                        `&track_action=project_share_info&track_id=${this.$route.query.id}&track_uuid=${sessionStorage.getItem('page_uuid')}`
                }
            });
            clipboard.on("success", function () {
                that.$common.pushEvent('project_share_info', that.$route.query.id);
                Toast({
                    message: "复制成功",
                    duration: 1200,
                });
                clipboard.destroy();
            });
            clipboard.on("error", function () {
                Toast({
                    message: "复制失败",
                    duration: 1200,
                });
            });
            // copyDom.style.position = "absolute";
            // copyDom.style.top = "0px";
            // copyDom.style.right = "-9999px";
            // document.body.appendChild(copyDom);
            // console.log(copyDom.innerTex)
            // //创建选中范围
            // var range = document.createRange();
            // range.selectNode(copyDom);
            // //移除剪切板中内容
            // window.getSelection().removeAllRanges();
            // //添加新的内容到剪切板
            // window.getSelection().addRange(range);
            // //复制
            // var successful = document.execCommand("copy");
            // copyDom.parentNode.removeChild(copyDom);
            // try {
            //     var msg = successful ? "successful" : "failed";
            //     Toast({
            //         message: "复制成功",
            //     });
            // } catch (err) {
            //     Toast({
            //         message: "复制失败",
            //     });
            // }
        },
        getQyhh() {
            this.$store.commit("loadSwitch", true);
            let that = this;
            let confit = this.shareConfit;
            //分享到会话
            wx.ready(() => {
                wx.invoke("getContext", {}, function (res) {
                    that.$store.commit("loadSwitch", false);
                    //  console.log("分享到会话", res);
                    if (res.err_msg == "getContext:ok") {
                        let entry = res
                            .entry; //返回进入H5页面的入口类型，目前有normal、contact_profile、single_chat_tools、group_chat_tools
                        if (entry == "normal") {
                            wx.invoke(
                                "shareAppMessage", {
                                    title: confit.share_friend_title, // 分享标题
                                    desc: confit.share_friend_desc, // 分享描述
                                    imgUrl: confit.share_img_url, // 分享封面
                                    link: confit.share_link, // 分享链接
                                },
                                function (res) {
                                    //  console.log("企业微信会话", res);
                                    if (res.err_msg == "shareAppMessage:ok") {
                                        // that.$emit("update:bShowNrom", false);
                                    } else if (
                                        res.err_msg == "shareAppMessage:cancel"
                                    ) {
                                        // that.$emit("update:bShowNrom", false);
                                    }
                                }
                            );
                        } else if (
                            entry == "single_chat_tools" ||
                            entry == "group_chat_tools"
                        ) {
                            wx.invoke(
                                "sendChatMessage", {
                                    msgtype: "news", //消息类型，必填
                                    news: {
                                        link: confit.share_link, //H5消息页面url 必填
                                        title: confit.share_friend_title, //H5消息标题
                                        desc: confit.share_friend_desc, //H5消息摘要
                                        imgUrl: confit.share_img_url, //H5消息封面图片URL
                                    },
                                },
                                function (res) {
                                    //  console.log("服务指引返回结果", res);
                                    if (res.err_msg == "sendChatMessage:ok") {
                                        // that.$emit("update:bShowNrom", false);
                                        //发送成功
                                    } else if (
                                        res.err_msg == "shareAppMessage:cancel"
                                    ) {
                                        // that.$emit("update:bShowNrom", false);
                                    }
                                }
                            );
                        }
                    } else {
                        //  console.log("错误处理");
                        //错误处理
                    }
                });
            });
        },
        // 生成二维码
        crateQrcode() {
            setTimeout(() => {
                const {
                    id,
                    ut_source
                } = this.$route.query;
                this.qr = new QRCode("qrcode", {
                    width: 150,
                    height: 150, // 高度
                    text: `${window.location.protocol}//${window.location.host}${window.location.pathname}` +
                        `?id=${id}&qywxUserId=${this.$storage.getStorage("user_id")}&ut_source=${ut_source}` + `&shareId=${this.$storage.getStorage("user_id")}` +
                        `&track_action=project_share_info&track_id=${this.$route.query.id}&track_uuid=${sessionStorage.getItem('page_uuid')}`, // 二维码内容
                });
            }, 200);
        },
        // 生成长图
        htmlToImage() {
            setTimeout(() => {
                console.log((this.$refs.qrcode.innerHTML = ""));
            }, 200); //清除上一次生成的二维码
            this.shareImg = true;
            this.bShareVisible = false;
            this.crateQrcode();
            setTimeout(() => {
                let sHeight =
                    document.querySelector(".share-wrap").offsetHeight;
                let sWidth = document.querySelector(".share-wrap").offsetWidth;
                var scale = 2;
                html2canvas(this.$refs.canvas, {
                    useCORS: true,
                    backgroundColor: null,
                    height: sHeight,
                    width: sWidth,
                    dpi: window.devicePixelRatio,
                    scale: scale,
                })
                    .then((canvas) => {
                        this.$common.pushEvent('project_share_info', this.$route.query.id);
                        let sUrl = canvas.toDataURL("image/png");
                        this.codeUrl = sUrl;
                    })
                    .catch((fail) => {
                        //  console.log(fail);
                    });
            }, 400);
        },
        /**
         * 分享按钮点击
         * @param shareItem
         */
        btnClickShare(shareItem) {
            const {
                key
            } = shareItem;

            switch (key) {
                case "link":
                    const clipboard = new this.$clipboard("#express_info_link");
                    clipboard.on("success", function () {
                        Toast({
                            message: "复制成功",
                            duration: 1200,
                        });
                        clipboard.destroy();
                    });
                    clipboard.on("error", function () {
                        Toast({
                            message: "复制失败",
                            duration: 1200,
                        });
                    });

                    break;
                case "banner":
                    break;
            }
        },
        /**
         * 保存报告数据到视图数据中
         */
        saveReportInfoToView(
            result = this.reportDetail,
            detail = this.projectDetail
        ) {

            this.arrInfoOptionList = this.arrInfoOptionList.map((i) => {
                if (["house_area_name", "quoted_price"].includes(i.key)) {
                    i.value = Number.parseFloat(detail[i.key]) || 0;
                } else if (i?.keys?.forEach) {
                    i.value = i.keys.reduce(
                        (pre, item) => pre + detail[item] || "",
                        ""
                    );
                } else {
                    i.value = detail[i.key];
                }
                return i;
            });

            // 项目的状数组
            (() => {
                const map = new Map();
                const list = [];
                console.log(detail, "detail");
                detail.items.forEach((i) => {
                    map.set(i.name.split("（")[0], {
                        state: i.id,
                        over: !!i.is_reach,
                    });
                });
                map.forEach((value, key) => {
                    list.push({
                        ...value,
                        name: key
                    });
                });
                this.arrConstStateList = list;
                // console.log(list)
                list.every((i) => {
                    i.over && (this.arrConstState = i.state);
                    return i.over;
                });
            })();

            // 时间分享信息
            this.arrInfoStateTList = this.arrInfoStateTList.map((i) => {
                i.value = detail[i.key] ? detail[i.key] : detail[i.key2];
                i.key === "created_at" && (i.value = detail[i.key].split(" ")[0]);
                return i;
            });

            // 家庭信息
            (() => {
                let arr = result.tags != undefined ? result.tags : [];
                const familyIn = JSON.stringify(
                    arr.find((i) => i.type === 2)?.items
                );
                let hasChild;
                let hasOlder;
                if (familyIn != undefined) {
                    hasChild = familyIn.includes("小孩");
                    hasOlder = familyIn.includes("老人");
                }

                let desc;
                if (hasChild && hasOlder) {
                    desc = "包含老人、儿童";
                } else if (hasChild) {
                    desc = "包含儿童";
                } else if (hasOlder) {
                    desc = "包含老人";
                }
                this.objFamilyInfo.desc = desc
            })();
            // 获取生成海报图所需的图片
            let items = this.projectDetail.items;


            let url = "";
            items.forEach((item) => {
                if (item.name == "空调施工") {
                    item.lists.forEach((it) => {
                        if (it.name == "风机盘管安装") {
                            url = it.lists[0].standard_photograph_url;
                        }
                    });
                }
            });
            this.sPosterUrl = url;
            let obj = this.$store.state.proposalModule.projectDetail;
            console.log("--->", obj);
            console.log(this.$store.state.proposalModule.projectDetail);
            //微信分享参数
            const {
                id,
                ut_source
            } = this.$route.query;

            let confit = {
                share_friend_title: obj.type + " | " + obj.city + obj.plot_name + "项目案例",
                share_friend_desc:
                    `${obj.house_area_name ? obj.house_area_name + ' ' : ''}` +
                    `${obj.house_type_name ? obj.house_type_name : ''}` +
                    `${obj.house_type_room_name ? obj.house_type_room_name + ' ' : ''}` +
                    `${obj.house_cate_name ? obj.house_cate_name : ''}`,
                share_img_url: url,
                share_link: `${window.location.protocol}//${window.location.host}${window.location.pathname}` +
                    `?id=${id}&qywxUserId=${this.$storage.getStorage("user_id")}&ut_source=${ut_source}` +
                    `&shareId=${this.$storage.getStorage("user_id")}&acc_id=${this.acc_id}` +
                    `&track_action=project_share_info&track_id=${this.$route.query.id}&track_uuid=${sessionStorage.getItem('page_uuid')}` +
                    `&sfrom=${this.$route.query.ut_source}&from_id=${this.$storage.getStorage("user_id")}&bSelfDemo=${this.isCurrent}`
            };
            // console.log(this.config.share_link)
            console.log("1111--->", confit);
            this.shareConfit = confit;
            this.wxStare(confit);
        },
        //jssdk 微信分享
        wxStare(config) {
            // oRequest.reportErr('projectDetail', {type: 'log',msgText: '项目详情2'}, {...this.projectDetail})
            // oRequest.reportErr('wxStare', {type: 'log',msgText: '分享参数'}, {...config})
            getWxSingleConfig(config);
        },
        /**
         * 保存入口实例
         */
        saveIndexRef() {
            this.$store.commit({
                type: "projectDetailConstruction/SAVE_INDEX_PAGE_REF",
                ref: this.$refs.pageView,
            });
        },
        /**
         * 子路由跳转
         * @param {string} path
         */
        async navToChildRouter(path) {
            const query = this.$route.query;
            await this.$router.replace({
                path,
                query
            });
            // 取出储存的位置
            const arrRouteType = path.split("/");
            const sRouteType = arrRouteType[arrRouteType.length - 1];
            // 跳转回页首
            this.$refs.pageView.scrollTo({
                top: this.objRouterPosition[sRouteType] ?? 0,
            });
        },

        /**
         * 改变分享弹窗显示
         */
        handleChangeShareVisible() {
            this.bShareVisible = !this.bShareVisible;
        },
        changeCatalogList(isCollect = this.projectDetail?.is_collect) {
            this.arrCatalogList = this.arrCatalogList.map((i) => {
                if (i.key === "save") i.name = isCollect ? "取消收藏" : "收藏";
                return i;
            });
        },
        /**
         * 目录点击
         * @param {'menu' | 'save' | 'share'} item
         */
        handleCatalogClick(item) {
            switch (item) {
                case "menu":
                    this.handleChangeAnchorToast();
                    break;
                case "share":
                    this.handleChangeShareVisible();
                    break;
                case "save":
                    this.changeProjectSaveState();
            }
        },
        /**
         * 改变收藏状态
         */
        changeProjectSaveState() {
            this.$toast("此功能暂未开放");

            // oDetail.getProjectCollect({
            //     xid: this.projectDetail.id,
            //     type: "topic",
            // }).then(res => {
            //     this.changeCatalogList(res.result.collect)
            // })
        },
        /**
         * 改变锚点目录框显示
         */
        handleChangeAnchorToast() {
            this.bAnchorToastVisible = !this.bAnchorToastVisible;
        },

        /**
         * 页面滚动处理
         * @param event
         */
        handleScroll(event) {
            const scrollTop = event.target.scrollTop;
            // this.bCatalogVisible = this.nScrollTop > scrollTop;
            this.nScrollTop = scrollTop;
        },
        /**
         * 跳转工地直击
         */
        async navToGD(key) {
            this.handleChangeAnchorToast();
            this.handleNavToCatalog(key);
        },
        handleNavToCatalog(key) {
            const arrOpen =
                this.$store.state.projectDetailConstruction.arrOpenCategoryKey;
            // 这里是处理工地直击展开问题
            const hasKey = arrOpen.includes(key) || arrOpen.includes("all");
            !hasKey &&
            this.$store.commit({
                type: "projectDetailConstruction/CHANGE_CATEGORY_OPEN_KEY",
                key,
            });

            // 延迟拿到节点的offset跳转
            const timer = setTimeout(() => {
                clearTimeout(timer);
                const id = "#" + this.sAnchorBefore + key;
                const el = document.querySelector(id);
                // 向下偏移一点距离 80
                this.$store.state.projectDetailConstruction.objIndexPageRef.scrollTo({
                    top: el.offsetTop - 80
                });
            }, 100);
        },
    },
};
</script>
<style>
#qr-right > img {
    width: 100% !important;
    height: 100% !important;
}

#qr-right > canvas {
    width: 100% !important;
    height: 100% !important;
}
</style>
<style scoped lang="scss">
.poster {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.6);
    z-index: 99;

    .poster-content {
        width: 564px;
        height: fit-content;
        background: #fff;
        position: absolute;
        top: 200vh;
        left: 0;
        margin: 0 auto;
        z-index: 1;
        // border-radius: 24px;
        overflow: hidden;

        .top-title {
            padding: 28px 28px 28px 38px;
            // background: linear-gradient(180deg, #1D4B9A 0%, #102960 100%);
            background: #1D4B9A;
            // border-radius: 16px 16px 0 0;
            width: calc(100% + 10px);
            transform: translateX(-10px);

            .text {
                font-size: 32px;
                font-weight: 600;
                color: #FFFFFF;
                line-height: 44px;
            }

            .name {
                font-size: 24px;
                font-weight: 400;
                color: rgba(255, 255, 255, 0.6);
                line-height: 28px;
                text-align: right;
            }
        }

        .poster-bgc {
            width: 100%;
            height: 310px;
            display: flex;
            align-items: center;
            justify-content: center;
            object-fit: cover;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }

        .title {
            font-size: 28px;
            font-weight: 400;
            color: #222222;
            line-height: 40px;
            margin-top: 24px;
            padding: 0 28px;
        }

        .info {
            margin-top: 8px;
            display: flex;
            align-items: center;
            padding: 0 28px;

            .info-item {
                display: flex;
                align-items: center;
                margin-right: 32px;

                img {
                    width: 24px;
                    height: 24px;
                    margin-right: 8px;
                }

                span {
                    font-size: 24px;
                    font-weight: 400;
                    color: #AEAEAE;

                }
            }
        }

        .qr-wrap {
            width: 488px;
            height: 172px;
            background: #EBF0F7;
            border-radius: 12px;
            margin: 48px 20px 0 auto;
            padding: 0 16px 0 44px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: relative;

            .qr-left {
                flex: 1;

                .top-qr {
                    display: flex;
                    align-items: center;

                    .name {
                        font-size: 20px;
                        font-weight: 400;
                        color: #666666;
                    }

                    .tag {
                        margin-left: 12px;
                        font-size: 20px;
                        font-weight: 400;
                        color: #AEAEAE;
                    }
                }

                .b-qr {
                    margin-top: 22px;
                    font-size: 28px;
                    font-weight: 600;
                    color: #222222;
                    line-height: 40px;
                }

            }

            .qr-right {
                width: 148px;
                height: 148px;
                background: #ffffff;

                img {
                    width: 100%;
                    height: 100%;
                }
            }

            .qr-head {
                width: 56px;
                height: 56px;
                border-radius: 50%;
                position: absolute;
                top: 12px;
                left: -28px;
                background: #102960;
                object-fit: cover;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    border-radius: 50%;
                }
            }
        }

        .b-bg {
            width: 100%;
            height: 124px;
            background: #F7F7F7;
            margin-top: 68px;
            padding: 20px 20px 0 28px;
            display: flex;
            justify-content: space-between;

            .logo-img {
                display: flex;
                flex-direction: column;
                white-space: nowrap;
                align-items: center;
                width: 272px;

                img {
                    width: 272px;
                    height: 32px;
                }

                span {
                    display: inline-block;
                    text-align: justify;
                    font-weight: 400;
                    font-size: 24px;
                    color: #004097;
                    line-height: 32px;
                    white-space: nowrap;
                    margin-top: 8px;
                }
            }

            .sp {
                img {
                    width: 202px;
                    height: 120px;
                    transform: translateY(-50px);
                }
            }
        }
    }

    .poster-content-img-wrap {
        width: 564px;
        height: 95vh;
        border-radius: 24px 24px 0 0;
        overflow-y: scroll;
        position: absolute;
        left: 50%;
        top: 5%;
        transform: translate(-50%, 0);
        padding-bottom: 40px;
        box-sizing: border-box;
    }

    .poster-content-img {
        width: 100%;
        height: fit-content;
        margin: 0 auto;
        position: relative;


        .img_box {
            width: 100%;
            max-height: 70vh;
            border-radius: 24px;
            overflow-y: scroll;
        }

        img {
            width: 100%;
            border-radius: 24px;
        }

        .close {
            width: 68px;
            height: 68px;
            position: absolute;
            bottom: -90px;
            left: 50%;
            transform: translateX(-50%);
        }

        .tips-save {
            position: absolute;
            bottom: -160px;
            left: 50%;
            transform: translateX(-50%);
            color: #f7f7f7;
            letter-spacing: 4px;
            text-align: center;
        }
    }
}

.share-popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.6);
    z-index: 99;

    .share-content {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 264px;
        background: #FFFFFF;
        border-radius: 24px 24px 0px 0px;
        padding: 20px 60px;

        .share-title {
            text-align: center;
            font-size: 28px;
            font-weight: 400;
            color: #328444;
            line-height: 40px;
        }

        .share-wrap {
            display: flex;
            align-items: center;
            margin-top: 30px;

            .share-item {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                img {
                    width: 80px;
                    height: 80px;
                    margin-bottom: 8px;
                }

                span {
                    font-size: 24px;
                    font-weight: 400;
                    color: #808080;
                    line-height: 34px;
                }
            }
        }
    }
}

.swipe-box {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 9999;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.6);

    .swipe-close {
        position: absolute;
        top: 28px;
        right: 28px;

        img {
            width: 38px;
            height: 38px;
        }
    }

    .directive {
        position: absolute;
        top: 28px;
        left: 50%;
        // z-index: 1200;
        transform: translate(-50%);
        color: #fff;
        font-size: 28px;
        padding: 4px 18px;
        background: rgba(0, 0, 0, 0.6);
        border-radius: 2px;
    }

    .swipe-image {
        position: relative;
        // position: absolute;
        width: 100vw;
        height: 100vh;

        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }

    .meng-img {
        position: relative;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;

        video {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }

        .video-img {
            position: absolute;
            left: 0;
            top: 0;
            z-index: 1;

            img {
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
        }

        .video_mantle {
            position: absolute;
            width: 100%;
            height: 100%;
            left: 50%;
            top: 0;
            z-index: 2;
            transform: translate(-50%);
            background: rgba(0, 0, 0, 0.5);
            border-radius: 10px;

            img {
                position: absolute;
                top: calc(50% - 39px);
                left: calc(50% - 39px);
                width: 78px;
                height: 78px;
            }
        }
    }
}

.mencheng {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    background: rgba(0, 0, 0, 0.5);

    .meng-img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        display: flex;
        justify-content: center;

        .meng-image {
            width: 75%;
            height: auto;
        }

        video {
            width: 75%;
            height: auto;
        }

        .video_mantle {
            position: absolute;
            width: 75%;
            height: 100%;
            left: 50%;
            top: 0;
            transform: translate(-50%);
            background: rgba(0, 0, 0, 0.5);
            border-radius: 10px;

            img {
                position: absolute;
                top: calc(50% - 39px);
                left: calc(50% - 39px);
                width: 78px;
                height: 78px;
            }
        }
    }

    .close_icon {
        position: absolute;
        right: 28px;
        top: 28px;
        z-index: 10;

        img {
            width: 48px;
            height: 48px;
        }
    }
}

.ceshi {
    width: 50px;
    height: var('--percen');
    background: red;
}

.ceshi-img {
    position: relative;

    img {
        position: absolute;
        width: 200px;
        height: 200px;
        clip: rect(0px, 50px, 200px, 0px);
    }
}


$BorderStyle: 1px solid rgba($defaultGary, 0.3);

#express_info_right {
    position: absolute;
    top: -99999px;
}

.share_popup {
    background: transparent;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.shareUrlWrap {
    width: 696px;
    height: 934px;
    // background: #FFFFFF;
    border-radius: 24px;
    overflow: hidden;
    position: relative;
}

.btn_share {
    width: 348px;
    height: 92px;
    background: #318544;
    border-radius: 51px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 32px;
    margin-top: 60px;
    box-sizing: border-box;
}

.topback {
    width: 100%;
    height: 364px;
    display: flex;
    padding: 22px 0;
    box-sizing: border-box;
    align-items: flex-end;
}

.shareinfo {
    display: flex;
    align-items: center;
    width: 100%;
    height: 68px;

    .shareinfo_item {
        width: 25%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        color: #fff;
        font-size: 28px;
        position: relative;

        .xian {
            content: "";
            display: inline-block;
            width: 1px;
            height: 60px;
            background: #909090;
            position: absolute;
            right: 0;
            top: 0;
            bottom: 0;
            margin: auto 0;
        }

        &:last-child .xian {
            width: 0;
        }

        div {
            span {
                color: #fff;
            }
        }

        span {
            font-size: 24px;
            color: #909090;
        }
    }
}

.code_info {
    width: 100%;
    height: 586px;
    background: #ffffff;
    border-radius: 16px 16px 16px 16px;
    margin-top: -16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 38px 0 30px 0;
    box-sizing: border-box;

    .address {
        color: #318544;
        font-size: 40px;
        font-weight: 700;
    }

    .code_url {
        width: 268px;
        height: 268px;
        margin: 34px 0 6px 0;
    }

    .color_test {
        margin-top: 13px;
        color: #318544;
    }

    div {
        margin-top: 6px;
        font-size: 28px;
        color: #858585;
    }
}

.btn_daochu {
    width: 384px;
    height: 84px;
    background: #318544;
    box-shadow: 0px 4px 8px 0px rgba(49, 133, 68, 0.2);
    border-radius: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 26px;
    margin: 0 auto;
}

.detail-page {
    height: 100vh;
    color: $defaultBlack;
    box-sizing: border-box;
    overflow: auto;
    scroll-behavior: smooth;
    background: #fff;

    .construction-state-warp {
        padding: 26px 24px 42px;

        .construction-state-content {
            border-radius: 10px;
            overflow: hidden;
            font-size: $baseSize;
            box-shadow: $boxShadow;

            .info-view {
                background: $greenGradient;
                color: #ffffff;
                padding: 76px 24px 46px;
                position: relative;

                .state-tag {
                    position: absolute;
                    right: 0;
                    top: 0;
                    width: 140px;
                    height: 60px;
                    color: $defaultGreen;
                    font-size: $bigSize;
                    font-weight: 700;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border-radius: 0 0 0 10px;
                    background-color: #a2e3aa;
                }

                .info-title {
                    font-size: 36px;
                    font-weight: 500;
                    margin-bottom: 16px;
                }

                .info-time-share {
                    color: rgba(#ffffff, 0.4);
                    display: flex;
                    margin-bottom: 52px;

                    .time-share-item {
                        margin-right: 48px;
                        display: flex;
                        align-items: center;

                        img {
                            width: 32px;
                            height: 32px;
                            margin-right: 2px;
                        }
                    }
                }

                .info-option {
                    display: flex;
                    justify-content: space-around;
                    align-items: stretch;
                    margin-bottom: 42px;

                    .info-option-item {
                        flex: 0 0 25%;
                        position: relative;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: flex-end;
                        color: #ffffff;

                        &::after {
                            opacity: 0.6;
                            position: absolute;
                            right: 0;
                            content: "";
                            height: 82px;
                            width: 2px;
                            background: #f1f1f1;
                        }

                        &:last-child::after {
                            width: 0;
                        }

                        &:nth-child(1) {
                            flex: 0 0 21%;
                        }

                        &:nth-child(2) {
                            flex: 0 0 31%;
                        }

                        &:nth-child(3) {
                            flex: 0 0 23%;
                        }

                        .option-value {
                            font-size: 40px;
                            color: #ffffff;

                            //margin-bottom: 10px;
                            line-height: 54px;

                            .util {
                                font-size: $baseSize;
                                line-height: 20px;
                            }
                        }

                        .mini-title {
                            opacity: 0.6;
                            font-size: $smallSize;
                        }

                        .num-value {
                            font-size: 40px;
                            line-height: 54px;
                            margin-bottom: 0;
                        }

                        .num-value-text {
                            font-size: 26px;
                            white-space: nowrap;
                        }
                    }
                }

                .info-family {
                    display: flex;
                    align-items: center;
                    color: rgba(#ffffff, 0.6);

                    div {
                        margin-right: 20px;
                    }

                    .title {
                        line-height: 46px;
                        width: 140px;
                        border-radius: 46px;
                        text-align: center;
                        border: 1px solid $simpleGreen;
                    }
                }
            }

            .state-view {
                height: 186px;
                font-size: $baseSize;
                display: flex;
                align-items: stretch;
                justify-content: space-between;
                padding-top: 16px;

                .state-cons-item {
                    flex: 1 1 auto;
                    height: 134px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    flex-direction: column;

                    .line-icon {
                        width: 100%;
                        height: 58px;
                        position: relative;
                        display: flex;
                        justify-content: center;
                        align-items: flex-start;

                        .line {
                            flex: 1;
                            height: 29px;
                            border-bottom: 1px solid #e9e9e9;
                        }

                        .line-hidden {
                            visibility: hidden;
                        }

                        .select-icon {
                            width: 58px;
                            height: 58px;
                            position: absolute;
                            z-index: 10;
                        }
                    }

                    .title {
                        text-align: center;
                        max-width: 120px;
                    }

                    .font-qu {
                        max-width: 60px;
                    }
                }

                .active-state-cons-item {
                    color: $defaultGreen;
                    font-weight: 600;

                    //&:nth-child(3) {
                    //    .line:nth-child(2) {
                    //        border-bottom-color: #e9e9e9 !important;
                    //    }
                    //}

                    .line-icon {
                        .line {
                            border-bottom: 1px solid $defaultGreen;
                        }
                    }
                }
            }
        }
    }

    .user-headImg-box {
        padding: 0px 24px 28px 24px;

        .user-headImg {
            background: #FFFFFF;
            box-shadow: 0px 0px 12px 0px #D6E6DA;
            border-radius: 16px;
            padding: 32px 22px 28px 28px;

            .headImg-top {
                display: flex;
                justify-content: space-between;

                .more-top {
                    font-size: 32px;
                    font-weight: 600;
                    color: #262525;
                }

                .more-top-right {
                    display: flex;

                    .top-look-more {
                        font-size: 24px;
                        color: #C2C2C2;
                    }

                    .top-look-icon {
                        img {
                            width: 32px;
                            height: 32px;
                        }
                    }
                }
            }

            .headImg-box {
                display: flex;
                margin-top: 28px;

                .head-name-box {
                    margin-right: 48px;

                    .head-img-assess {
                        img {
                            width: 72px;
                            height: 72px;
                            border-radius: 50%;
                        }
                    }

                    .assess-name {
                        text-align: center;
                        margin-top: 12px;
                        font-size: 24px;
                        color: #909090;
                    }
                }

                .more-assess-box {
                    .head-img-assess {
                        img {
                            width: 72px;
                            height: 72px;
                            border-radius: 50%;
                        }
                    }

                    .assess-name {
                        text-align: center;
                        margin-top: 12px;
                        font-size: 24px;
                        color: #909090;
                    }
                }
            }
        }
    }

    .user-assess {
        padding: 0px 24px 28px 24px;

        .assess-box {
            background: #FFFFFF;
            box-shadow: 0px 0px 12px 0px #D6E6DA;
            border-radius: 16px;
            padding: 32px 22px 28px 28px;

            .top-box {
                display: flex;
                justify-content: space-between;

                .top-left {
                    font-size: 32px;
                    font-weight: 600;
                    color: #262525;
                }

                .top-right {
                    font-size: 24px;
                    color: #C2C2C2;
                    display: flex;
                    align-items: center;

                    img {
                        width: 32px;
                        height: 32px;
                    }
                }
            }

            .assess-label {
                display: flex;
                flex-wrap: wrap;

                .label-item {
                    margin-top: 20px;
                    padding: 6px 24px;
                    background: #EAF1EF;
                    border-radius: 28px;
                    font-size: 28px;
                    color: #739E82;
                    margin-right: 16px;
                }

                .lable-item {
                    margin-top: 20px;
                    padding: 6px 24px;
                    background: #318544;
                    border-radius: 28px;
                    font-size: 28px;
                    color: #FFFFFF;
                    margin-right: 16px;
                    // box-sizing: border-box;
                }
            }

            .user-info {
                margin-top: 34px;
                display: flex;
                justify-content: space-between;

                .user-left-box {
                    display: flex;

                    .head-img {
                        img {
                            width: 80px;
                            height: 80px;
                            border-radius: 50%;
                        }
                    }

                    .user-name {
                        margin-left: 16px;

                        .current-name {
                            display: flex;

                            .name {
                                font-size: 28rpx;
                                font-weight: 600;
                                color: #444444;
                            }

                            .current {
                                padding: 2px 22px;
                                margin-left: 28px;
                                background: #EAF1EF;
                                font-size: 24px;
                                font-weight: 400;
                                color: #739E82;
                                border-radius: 20px;
                            }
                        }

                        .time {
                            margin-top: 12px;
                            font-size: 24px;
                            color: #C2C2C2;
                        }
                    }
                }

                .user-right-box {
                    // width: 112px;
                    height: 52px;
                    padding: 10px 8px 10px 20px;
                    box-sizing: border-box;
                    border-radius: 26px 0 0 26px;
                    font-size: 24px;
                    background: rgba(255, 179, 3, 0.1);
                    color: #EFA104;
                    margin-right: -22px;

                    img {
                        width: 32px;
                        height: 32px;
                        margin-right: 6px;
                    }
                }
            }

            .stars-title {
                font-size: 28px;
                color: #858585;
                margin-right: 24px;
            }

            .assess-stars {
                margin-top: 22px;
                display: flex;

                .stars-title {
                    font-size: 28px;
                    color: #858585;
                    margin-right: 24px;
                }

                .stars-box {
                    width: 230px;
                    position: relative;

                    .stars-hig-box {
                        position: absolute;
                        display: flex;
                        z-index: 5;

                        .stars-hig {
                            position: relative;

                            .stars-img {
                                margin-right: 12px;
                                width: 32px;
                                height: 32px;
                            }

                            .stars-img-item {
                                position: absolute;
                                margin-right: 12px;
                                width: 32px;
                                height: 32px;
                                clip: rect(0px, var(--percen), 32px, 0px);
                                // clip:rect(0px , 19px , 32px , 0px);
                            }
                        }
                    }

                    .stars-ash-box {
                        position: absolute;
                        display: flex;
                        z-index: 4;

                        .stars-ash {
                            img {
                                margin-right: 12px;
                                width: 32px;
                                height: 32px;
                            }
                        }
                    }
                }
            }

            .assess-content {
                margin-top: 24px;
                font-size: 28px;
                color: #444444;
            }

            .assess-imgae {
                width: 100%;
                // height: 208px;
                display: flex;
                flex-wrap: wrap;

                // justify-content: space-between;
                .assess-imgae-item {
                    position: relative;
                    margin-left: 10px;
                    margin-top: 28px;

                    img {
                        width: 198px;
                        height: 198px;
                        border-radius: 10px;
                        object-fit: cover;
                    }

                    video {
                        width: 198px;
                        height: 198px;
                        border-radius: 10px;
                    }

                    .video_mantle {
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        left: 0;
                        top: 0;
                        background: rgba(0, 0, 0, 0.5);
                        border-radius: 10px;

                        img {
                            position: absolute;
                            top: calc(50% - 39px);
                            left: calc(50% - 39px);
                            width: 78px;
                            height: 78px;
                        }
                    }
                }
            }

            .assess-voice {
                margin-top: 36px;
                position: relative;
                right: -20px;
                top: 0;
                width: 514px;
                height: 64px;
                background: #F7F7F7;
                border-radius: 10px;
                font-size: 28px;
                color: #6C9276;
                display: flex;
                justify-content: flex-end;
                align-items: center;

                .voice-icon {
                    margin: 0 26px 0 16px;
                    position: relative;
                    width: 32px;
                    height: 32px;

                    img {
                        width: 32px;
                        height: 32px;
                    }

                    .icon1 {
                        position: absolute;
                        left: 50%;
                        transform: translate(-50%);
                        top: 0;
                        width: 8px;
                        height: 32px;
                        z-index: 2;
                    }

                    .mengceng {
                        position: absolute;
                        left: 50%;
                        transform: translate(-50%);
                        top: 0;
                        width: 8px;
                        height: 32px;
                        background: #F7F7F7;
                        z-index: 1;
                        animation: title 2s infinite;
                    }

                    @keyframes title {
                        0% {
                            width: 8px;
                        }

                        40% {
                            width: 30px;
                        }

                        50% {
                            width: 32px;
                        }

                        90% {
                            width: 10px;
                        }

                        100% {
                            width: 8px;
                        }
                    }

                    // img {
                    //     margin: 0 26px 0 16px;
                    //     width: 32px;
                    //     height: 32px;
                    // }
                }

                .triangle-icon {
                    position: absolute;
                    width: 0;
                    height: 0;
                    border-top: 10px solid transparent;
                    border-right: 22px solid #F7F7F7;
                    border-bottom: 10px solid transparent;
                    top: 20px;
                    left: -20px;
                }
            }

            .split-line {
                margin-top: 40px;
                border: 2px dashed #E5E5E5;
            }

            .look-more {
                margin-top: 38px;
                text-align: center;
                font-size: 24px;
                color: #328444;

                img {
                    margin: 1px 0 0 4px;
                    width: 28px;
                    height: 28px;
                }
            }

            .look-more-item {
                margin-top: 38px;
                text-align: center;
                font-size: 24px;
                color: #328444;

                img {
                    transform: rotate(180deg);
                    margin: 1px 0 0 4px;
                    width: 28px;
                    height: 28px;
                }
            }
        }
    }

    .nav-wrap {
        height: 100px;
        display: flex;
        align-items: stretch;
        justify-content: space-around;
        border-bottom: $BorderStyle;
        border-top: $BorderStyle;
        color: $defaultBlack;
        position: sticky;
        top: 0;
        background: #ffffff;
        z-index: 8;

        .nav-item {
            flex: 1;
            font-size: $baseSize;
            //transition: all 0.5s;
            display: flex;
            justify-content: center;
            align-items: center;

            .nav-item-title {
                flex: 1;
                text-align: center;
                line-height: $baseSize;
            }

            .line-content {
                width: 126px;
                height: 6px;
                position: absolute;
                bottom: 0;
                background: $defaultGreen;
                opacity: 0;
            }
        }

        .active-nav-item {
            color: $defaultGreen;
            font-size: $bigSize;
            font-weight: 700;
            position: relative;

            .line-content {
                opacity: 1;
                transition: all 1s;
            }
        }
    }

    .catalog-content {
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 9;
        width: 100vw;
        background: transparent;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 34px;
        padding: 24px 68px 40px;

        .catalog-item {
            width: 184px;
            height: 80px;
            border-radius: 80px;
            border: 4px solid $defaultGreen;
            color: #ffffff;
            display: flex;
            align-items: center;
            background-color: $defaultGreen;
            justify-content: center;

            img {
                width: 36px;
                height: 36px;
                margin-right: 14px;
            }
        }

        .catalog-menu {
            color: $defaultGreen;
            background-color: #ffffff;
        }

        .anchor-catalog {
            box-shadow: $boxShadow;
            padding: 12px 24px;
            font-size: $baseSize;
            position: absolute;
            bottom: 160px;
            min-width: 200px;
            background: #ffffff;
            border-radius: 10px;

            .item {
                padding: 14px 0;
                color: $defaultGreen;
                font-weight: 700;
                display: block;
            }
        }
    }

    .share-action-sheet {
        padding: 36px;
        font-size: $baseSize;

        .title-box {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: $bigSize;
            margin-bottom: 34px;

            img {
                width: 32px;
                height: 32px;
            }
        }

        .share-box {
            margin-bottom: 58px;

            .share-item {
                height: 140px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 28px;
                background: #f0f4f1;
                border-radius: 10px;
                padding: 0 26px;

                .i-title {
                    display: flex;
                    align-items: center;

                    img {
                        width: 84px;
                        height: 84px;
                        margin-right: 20px;
                    }
                }

                .btn {
                    width: 164px;
                    height: 56px;
                    background: $defaultGreen;
                    border-radius: 56px;
                    display: flex;
                    font-size: 26px;
                    justify-content: center;
                    align-items: center;
                    color: #ffffff;
                    font-weight: 700;
                }
            }
        }
    }
}

.fade-up-enter-active {
    transition: all 0.4s ease;
}

.fade-up-leave-active {
    transition: all 0.2s ease-in-out;
}

.fade-up-enter,
.fade-up-leave-to {
    transform: translateY(-100%);
    opacity: 0;
}

.unwind-enter-active {
    transition: all 0.5s;
}

.unwind-leave-active {
    transition: all 0.3s;
}

.unwind-enter {
    opacity: 0;
}

.unwind-leave-to {
    height: 0;
    opacity: 0;
    padding: 0 !important;
}

.fade-down-enter-active {
    transition: all 0.5s;
}

.fade-down-leave-active {
    transition: all 0.3s;
}

.fade-down-enter,
.fade-down-leave-to {
    transform: translateY(200px);
}
</style>
<style lang="scss">
@keyframes audioStart {
    0% {
        width: 26px;
    }

    33% {
        width: 26px;
    }

    34% {
        width: 16px;
    }

    66% {
        width: 16px;
    }

    67% {
        width: 0;
    }

    100% {
        width: 0;
    }
}

.share-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
</style>
